export { EloArrowElbowDownRight } from './arrow-elbow-down-right'
